export default "__VITE_ASSET__Coz30pDP__"